import * as React from 'react';

import Text from 'crehana-ui/Text';
import PlayO from 'crehana-icons/PlayO';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

/**
 * This component is intended to be used for carrer and bundle cards
 */
const TotalCourses: React.FC<Partial<CourseCardProps>> = props => {
  const { totalCourses } = props;

  return totalCourses ? (
    <div className="TotalCoursesComponent flex items-center">
      <div style={{ marginRight: 6 }}>
        <PlayO size={13} />
      </div>
      <Text type="legals" color="gray-dark">
        {totalCourses} Cursos
      </Text>
    </div>
  ) : null;
};

export default TotalCourses;
